import { Buffer } from "buffer";
// @solana/web3.js expects a global Buffer in the browser
(globalThis as any).Buffer ??= Buffer;

import { createRoot } from "react-dom/client";
import "./styles.css";
import { Root, type DemoConfig } from "./App";

async function boot() {
  const cfg = (await fetch("/config").then((r) => r.json()).catch(() => ({}))) as Partial<DemoConfig>;
  const apiUrl = (cfg.apiUrl || `${location.protocol}//${location.hostname}:8090`).replace(/\/$/, "");
  createRoot(document.getElementById("root")!).render(<Root cfg={{ apiUrl, solanaRpc: cfg.solanaRpc || undefined, solanaProgram: cfg.solanaProgram || undefined, jupnetRpc: cfg.jupnetRpc || undefined, jupnetProgram: cfg.jupnetProgram || undefined }} />);
}
boot();
